<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    width="400px"
  >
    <el-input
      v-model="code"
      :disabled="this.type != 'new'"
      style="margin-bottom: 10px;"
      :placeholder="$t('app.bedCode')"
    >
    </el-input>
    <el-select
      v-model="status"
      :placeholder="$t('app.bedStatus')"
      style="width: 100%;margin-bottom: 10px;"
    >
      <el-option
        v-for="item in statusList"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button size="small" type="primary" @click="handleClose">{{
        $t("app.confirm")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      statusList: [
        { value: "1", label: "OOO" },
        { value: "2", label: "Vacant Clean" },
        { value: "3", label: "Vacant Dirty" },
        { value: "4", label: "Occupied" },
        { value: "5", label: "Occupied / Luggage" }
      ],
      dialogVisible: false,
      code: "",
      status: "",
      index: "",
      type: ""
    };
  },
  methods: {
    edit(index, row) {
      this.dialogVisible = true;
      this.code = row.code;
      this.status = row.status;
      this.index = index;
      this.type = "edit";
    },
    new() {
      this.dialogVisible = true;
      this.type = "new";
      this.status = "";
      this.code = "";
      this.index = "";
    },
    handleClose() {
      this.success();
    },
    success() {
      if (this.type === "edit") {
        this.$emit(
          "handleSuccess",
          {
            code: this.code,
            status: this.status
          },
          this.index
        );
      } else {
        this.$emit(
          "handleSuccess",
          {
            code: this.code,
            status: this.status
          },
          false
        );
      }
      this.dialogVisible = false;
    }
  }
};
</script>
